import React from "react";
import { Route, Switch, useHistory } from "react-router-dom";
import ReactTable from "./Reacttable/UserManagement/ReactTable";
import Sidebar from "./Sidebar";
import { connect, useDispatch } from "react-redux";

// import indexxx from "../test/indexxx";

import UserTableApproved from "./Reacttable/UserManagement/UserNewModule/UserTableApproved";
import Navbar from "./Navbar";
import Dashboard from "./Dashboard/Dashboard";
import Obd from "./Obd";
import AddEmployee from "./UserManagement/AddEmployee";
import AddLocation from "./UserManagement/AddLocation";
import ViewEmployees from "./UserManagement/Tables/ViewEmployee";
import AddLeave from "./LeaveManagement/EmployeeLeaveMangement/AddLeave";
import ViewLocations from "./UserManagement/Tables/ViewLocation";
import TransferDetails from "./TransferManagement/TranferDetais";
import MarkAttendance from "./LeaveManagement/EmployeeLeaveMangement/MarkAttendence";
import CSMMarkAttendance from "./LeaveManagement/CSMLeaveManagement/MarkAttendence";

import AddTravel from "./Travel/AddTravel";
import ViewTravels from "./Travel/ViewTravel";
import ViewTransfers from "./TransferManagement/TransferTable";
import Hello from "./Hello";

import ResellerDashboard from "./Dashboard/ResellerDashboard";
import AddLeaveCSM from "./LeaveManagement/CSMLeaveManagement/AddLeave";
import MarkAttendanceEMP from "./LeaveManagement/CSMLeaveManagement/MarkAttendanceEmp";
// import { setModalstatus } from "../../redux/features/ModalSlice";
import CSMEmployeeLeave from "./LeaveManagement/CSMLeaveManagement/AddLeave";
import AprovalAttendance from "./LeaveManagement/CSMLeaveManagement/ApprovalAttendance";
import OpsHead from "./Dashboard/OpsHead";
import MarkCSMAttendaance from "./LeaveManagement/OpsLeaveManagement/MarkCSMAttendaance";
import CSMAttendanceApprovals from "./LeaveManagement/OpsLeaveManagement/CSMAttendanceApprovals";
import HrAddEmployee from "./HR/HrAddEmployee";
import HrAddLocation from "./HR/HrAddLocation";
import HrManageEmployee from "./HR/HrManageEmployee";
import HrPendingRequest from "./HR/HrPendingRequest";
import HrAddNotice from "./HR/HrAddNotice";
import Sidebarupdated from "./Sidebarupdated";
import DisplayGuests from "./GuestsModule/DisplayGuests";

function index(props) {
  return (
    <>
      {/* <Sidebar /> */}
      <Sidebarupdated />
      <section
        // id="main-section-sidebar"
        className={props.sectionClass ? "ms-auto sec_1" : "ms-auto sec_2"}
        style={{ marginLeft: "auto", minHeight: "100vh" }}
      >
        <div className="home-content d-block">
          <Navbar />

          <Switch>
            {JSON.parse(localStorage.getItem("usermodal"))?.userGroups == 6 ? (
              <Route path="/" exact component={Dashboard} />
            ) : JSON.parse(localStorage.getItem("usermodal"))?.userGroups ==
              7 ? (
              <Route path="/" exact component={ResellerDashboard} />
            ) : JSON.parse(localStorage.getItem("usermodal"))?.userGroups ==
              8 ? (
              <Route path="/" exact component={OpsHead} />
            ) : JSON.parse(localStorage.getItem("usermodal"))?.userGroups ==
                10 ||
              JSON.parse(localStorage.getItem("usermodal"))?.userGroups ==
                11 ? (
              <Route path="/" exact component={ResellerDashboard} />
            ) : null}

            {/* ----------------------  HR -------------------------------- */}
            {/* 
            <Route
              path="/dashboard/AddEmployee"
              exact
              component={AddEmployee}
            /> */}

            {/* ----------------------  END -------------------------------- */}

            <Route
              path="/dashboard/ViewUsers"
              exact
              component={UserTableApproved}
            />
            <Route
              path="/dashboard/DocumentVerification"
              exact
              component={ReactTable}
            />

            {/* employee */}

            {JSON.parse(localStorage.getItem("usermodal"))?.userGroups == 11 ? (
              <Route
                path="/dashboard/AddEmployee"
                exact
                component={HrAddEmployee}
              />
            ) : (
              <Route
                path="/dashboard/AddEmployee"
                exact
                component={AddEmployee}
              />
            )}

            <Route
              path="/dashboard/ViewEmployees"
              exact
              component={ViewEmployees}
            />

            {/* employee  */}
            {/* lcoation */}

            {JSON.parse(localStorage.getItem("usermodal"))?.userGroups == 11 ? (
              <Route
                path="/dashboard/AddLocation"
                exact
                component={HrAddLocation}
              />
            ) : (
              <Route
                path="/dashboard/AddLocation"
                exact
                component={AddLocation}
              />
            )}

            <Route
              path="/dashboard/ViewLocations"
              exact
              component={ViewLocations}
            />
            {/* lcoation */}
            {/* Leave mngmmnt */}
            <Route path="/dashboard/RequestLeave," exact component={AddLeave} />
            <Route path="/dashboard/AddNotice" exact component={HrAddNotice} />
            <Route path="/dashboard/RequestLeave" exact component={AddLeave} />
            {/* <Route path="/dashboard/LeaveStatus" exact component={Leavetable} /> */}
            <Route
              path="/dashboard/MarkAttendance"
              exact
              component={Dashboard}
            />

            {/* CSM EMPloyee Routes */}
            <Route
              path="/dashboard/EmployeeLeave"
              exact
              component={CSMEmployeeLeave}
            />
            {JSON.parse(localStorage.getItem("usermodal"))?.userGroups == 10 ? (
              <Route
                path="/dashboard/EmployeeRecord"
                exact
                component={MarkCSMAttendaance}
              />
            ) : (
              <Route
                path="/dashboard/EmployeeRecord"
                exact
                component={MarkAttendanceEMP}
              />
            )}

            {/* CSM EMPloyee Routes */}
            <Route
              path="/dashboard/MarkAttendance,"
              exact
              component={CSMMarkAttendance}
            />
            <Route
              path="/dashboard/RequestLeave."
              exact
              component={AddLeaveCSM}
            />
            <Route
              path="/dashboard/MarkAttendance."
              exact
              component={CSMMarkAttendance}
            />
            <Route
              path="/dashboard/PendingApproval"
              exact
              component={AprovalAttendance}
            />

            {/* Leave mngmmnt */}
            {/* OPS Head Management */}
            <Route
              path="/dashboard/CSMRecord"
              exact
              component={MarkCSMAttendaance}
            />
            <Route
              path="/dashboard/PendingApprovals"
              exact
              component={CSMAttendanceApprovals}
            />

            {/* OPS Head Management */}

            {/* travel mngmnt */}
            <Route
              path="/dashboard/ViewTravels"
              exact
              component={ViewTravels}
            />
            <Route path="/dashboard/AddTravel" exact component={AddTravel} />

            {/* travel mngmnt */}
            {/* Transfer mngmnt */}
            <Route
              path="/dashboard/InitiateTransfer"
              exact
              component={TransferDetails}
            />
            <Route
              path="/dashboard/TransferDetails"
              exact
              component={ViewTransfers}
            />
            {/* Transfer mngmnt */}

            {/* Manage employee */}
            <Route
              path="/dashboard/ManageEmployee"
              exact
              component={HrManageEmployee}
            />
            <Route
              path="/dashboard/PendingRequest"
              exact
              component={HrPendingRequest}
            />

            {/* Tata ABuzzzz related code */}
            <Route
              path="/dashboard/GuestList"
              exact
              component={DisplayGuests}
            />
            {/* Tata ABuzzzz related code */}
            {/* Manage employee end */}
            {/* extra */}
            <Route path="/siesta" exact component={Obd} />
            {/* extra */}
          </Switch>
        </div>
      </section>
    </>
  );
}

const mapStateToProps = (state) => ({
  sectionClass: state.sidebarReducer.sectionClass,
});

export default connect(mapStateToProps)(index);
